// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2_bqL","row":"ProcedureTreatmentSummary_row__2Kc6M"};